import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

let locationKey = ''

class ScrollToTop extends React.Component {
    componentDidUpdate(prevProps) {
        const { elementId, location, indentElementId, isAccordion } = this.props

        if (location.pathname !== prevProps.location.pathname && location.key !== locationKey || isAccordion) {
            const indent = indentElementId ? document.getElementById(indentElementId).offsetHeight : 0
            const yCoord = elementId ? document.getElementById(elementId).offsetTop : 0
            locationKey = location.key

            window.scrollTo(0, yCoord - indent)
        }
    }

    render() {
        return this.props.children
    }
}

ScrollToTop.propTypes = {
    location: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    elementId: PropTypes.string,
    indentElementId: PropTypes.string,
    isAccordion: PropTypes.bool,
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/ScrollToTop.js